const termsConfig = {
    privacy: {
        divisionType: 'service',
        termsKey: 'cs_privacy'
    },
    stipulation: {
        divisionType: 'service',
        termsKey: 'cs_stipulation'
    },
    info: {
        divisionType: 'info',
        termsKey: 'cs_history'
    }
}

export default {
    methods:{
        returnTermsConfig(type){
            return termsConfig[type];
        }
    }
}

